// Section 17: the ration allocator as a pure function any resource can use. Build `ranked` with
// `rankGroups` (people) or `rankHouseholds` (warmth), then call `allocate`. It runs the named
// ration policy from the registry and enforces the engine's contract: shares in 0..1, never
// more than `available` in total. The arithmetic lives in core/allocation.ts (`allocateWith`)
// so phases outside this folder (the health phase's medicine triage) can call it too; the layer
// rules forbid importing this file from another phase.
import { allocateWith } from '../../core/allocation';
import type { Allocation, AllocationInput } from '../../core/registry';
import type { RationPolicyId, ReadContext } from '../../core/types';

export interface AllocateRequest extends AllocationInput {
  policy: RationPolicyId;
}

export function allocate(ctx: ReadContext, request: AllocateRequest): Allocation {
  const { policy, ...input } = request;
  return allocateWith(ctx.registry.rationPolicies[policy], ctx, input);
}

export { placeInOrder, rankGroups, rankHouseholds } from './groups';
